/*
 * @Author: your name
 * @Date: 2019-11-21 18:30:52
 * @LastEditTime: 2024-06-25 15:24:18
 * @LastEditors: mqlpcthree mql_pcthree@163.com
 * @Description: In User Settings Edit
 * @FilePath: /mei_qi_zeroweb_endlyq/src/main.js
 */
/**
 * 入口文件
 */
import 'babel-polyfill'
import 'element-ui/lib/theme-chalk/index.css'
import './common'
import './components'
import 'normalize.css/normalize.css' // A modern alternative to CSS resets
// import echarts from 'echarts'; //扇形图
// 导入控制文件
import './permission' // 全局路由拦截器
import App from './App'
import Vue from 'vue'
import Cookies from 'js-cookie'
import router from './router'
import store from './store'
import md5 from 'js-md5'
import cal from './common/calculation'
import * as echarts from 'echarts'
import * as Sentry from '@sentry/browser'
import { Vue as VueIntegration } from '@sentry/integrations'
import {
  Message,
  Tag,
  Drawer,
  Skeleton,
  SkeletonItem,
  link,
  Cascader,
  TimePicker
} from 'element-ui'
import overallSituation from './directive/overallSituation'
import focus from './directive/focus.js'
import directiveMaxNumberLength from './directive/maxNumberLength.js'
import Print from 'vue-print-nb'
import '../static/icon/iconfont.css' // 阿里字体图标库
import myKit from './utility_class/my_kit'
import('../static/icon/iconfont.js') // 个人工具类

Vue.use(TimePicker)
Vue.use(Print)
Vue.use(Tag)
Vue.use(Drawer)
Vue.use(link)
Vue.use(Skeleton)
Vue.use(SkeletonItem)
Vue.use(Cascader)
Vue.use(focus)
Vue.use(directiveMaxNumberLength)
Vue.prototype.overall = overallSituation
Vue.prototype.cal = cal
Vue.prototype.$md5 = md5
Vue.prototype.$echarts = echarts
Vue.prototype.$Message = Message
Vue.prototype.$MyKit = myKit

// 测试
// http://7ee9c65dee4d4763b66efde98c3e13f7@localhost:9000/5
// Sentry.init({
//     dsn: "http://87a3ba331bbc4a41b613e3ec649debd8@localhost:9000/4",
//     integrations: [new VueIntegration({ Vue, attachProps: true })],
//     logErrors: true,
//     release: "pro@1.0.2s"
// });

// // 正式
// Sentry.init({
//     dsn: "http://7ee9c65dee4d4763b66efde98c3e13f7@localhost:9000/5",
//     integrations: [new VueIntegration({ Vue, attachProps: true })],
//     logErrors: true,
//     release: "pro@1.0.2"
// });

Vue.config.productionTip = false
Cookies.json = true

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js